import {
    SET_PRODUCTS_DATA_LOADING,
    SET_PRODUCTS,
    SET_SEARCH_PRODUCTS,
    SET_SEARCH_PRODUCT_BY_ID,
    SET_FILTERED_PRODUCTS,
} from "../actions/types";

const initialState = {
    isLoading: false,
    productsData: [],
    filteredProductsTotal: 0,
    searchedProducts: [],
    searchedProductById: [],
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PRODUCTS_DATA_LOADING:
            return {
                ...state,
                isLoading: payload,
            };
        case SET_PRODUCTS:
            return {
                ...state,
                productsData: payload,
                isLoading: false,
            };
        case SET_SEARCH_PRODUCTS:
            return {
                ...state,
                searchedProducts: payload,
            };
        case SET_SEARCH_PRODUCT_BY_ID:
            return {
                ...state,
                searchedProductById: payload,
            };
        case SET_FILTERED_PRODUCTS: {
            const data = payload?.data ?? [];
            const total = payload?.totalRowCount ?? 0;
            console.log('[productsReducer] SET_FILTERED_PRODUCTS payload:', { dataLength: data?.length, total });
            return {
                ...state,
                productsData: data,
                filteredProductsTotal: total,
                isLoading: false,
            };
        }
        default:
            return state;
    }
}
